import script from "./ManageTenantsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageTenantsView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageTenantsView.vue?vue&type=style&index=0&id=5a954e5d&lang=scss"

const __exports__ = script;

export default __exports__